import PaymentTile from './PaymentTile.vue';

export { PaymentTile };
export default PaymentTile;
